module.exports = __webpack_public_path__ + "static/plane.72ac2ed2.svg";